import { createContext, useContext, useState, useEffect } from 'react';
import { checkMerlino, getMerlinoT, clearMerlino } from '../services/merlinoService';
import PropTypes from 'prop-types'; // Importa prop-types

// Context per l'autenticazione
const AuthContext = createContext();

// Hook per usare il contesto
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Stato di caricamento

  const checkAuth = async () => {
    const token = getMerlinoT();
    if (token) {
      try {
        await checkMerlino(); // Verifica se il token è valido
        setIsAuthenticated(true);
      } catch {
        clearMerlino(); // Rimuovi il token se non valido
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false); // Il controllo è completo
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    clearMerlino();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
